// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SingleSourceSvg from '@rsuite/icon-font/lib/file/SingleSource';
var SingleSource = createSvgIcon({
  as: SingleSourceSvg,
  ariaLabel: 'single source',
  category: 'file',
  displayName: 'SingleSource'
});
export default SingleSource;